module.exports = __webpack_public_path__ + "static/img/4.3cfce59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Infidelidad-Riesgos-Financieros/4.png
// module id = 22Wg
// module chunks = 0